import { EquipmentBrowseConfigureFilter } from '@models/interfaces';

export const equipmentBrowseDefaultConfigureFilter: EquipmentBrowseConfigureFilter =
  {
    equipmentTypeId: undefined,
    equipmentManufacturerId: undefined,
  };
